var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showOnMain || !_vm.isMainRoute)?_c('v-breadcrumbs',_vm._b({attrs:{"items":_vm.breadCrumbs},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{attrs:{"to":item.to,"exact":""}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}],null,false,1206969706)},'v-breadcrumbs',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }